// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import { RowDataChangedEvent } from 'wdna-grid-table/lib/types';
import Table from 'wdna-components/lib/table/Table';

import { JarvisWidget } from 'wdna-components/lib';
import Loader from 'wdna-components/lib/loaders/local/Loader';

import { ContextType, FilterContext } from '../../../../../types';

interface Props {
  level?: any;
  title: string;
}

interface State {
  loading: boolean;
}

export default class MainTable extends React.Component<Props, State> {
  private mounted: boolean;

  public static contextType: React.Context<ContextType> = FilterContext;
  public context: React.ContextType<typeof FilterContext> | undefined;

  public constructor(props: Props) {
    super(props);

    this.mounted = false;

    this.state = {
      loading: true,
    };
  }

  public componentDidMount = (): void => {
    this.mounted = true;
  };

  public rowDataChanged = (_event: RowDataChangedEvent): void => {
    this.setState({
      loading: false
    });
  };

  public render(): JSX.Element {
    const { loading } = this.state;
    const { dashboardData } = this.context?.parentState;

    const columnAliases: Record<string, string> = {
      id: 'ID',
      weight: 'Weight',
      tare: 'Tare',
      date: 'Date',
      containerType: 'Type',
      company: 'Company',
      containerId: 'Container Id',
      containerCode: 'Code',
      containerName: 'Name',
      containerDescription: 'Name',
    };
    const hiddenCols: string[] = [
      'id',
      'flags',
      'tare',
      'containerCode',
      'verified',
      'containerId',
      'containerName',
    ];
    const columnStyles: Record<string, any> = {
      id: { textAlign: 'right' },
      weight: { textAlign: 'right' },
      date: { textAlign: 'center' },
      containerType: { textAlign: 'left' },
      company: { textAlign: 'left' },
      containerId: { textAlign: 'right' },
      containerCode: { textAlign: 'right' },
      containerDescription: { textAlign: 'left' },
    };

    return (
      <JarvisWidget
        custombutton={false}
        fullscreenbutton={false}
        editbutton={false}
        togglebutton={false}
        colorbutton={false}
        deletebutton={false}
        height="calc(75vh)"
      >
        <div className="widget-body" style={{ paddingTop: '0px' }}>
          <Loader show={loading} overlay={false} />
          {dashboardData && (
            <Table
              loading={false}
              data={dashboardData || []}
              alias={columnAliases || []}
              hiddenCols={hiddenCols}
              customCellStyles={columnStyles}
              rowDataChanged={this.rowDataChanged}
              customColumnsDefs={{
                id: { suppressSizeToFit: false, minWidth: 80, maxWidth: 80 },
              }}
            />
          )}
        </div>
      </JarvisWidget>
    );
  }
}
